import React, { useRef } from 'react'
import GooglePlacesAutocomplete, { geocodeByAddress } from 'react-google-places-autocomplete'
import './styles.scss'

import GeneralInput from '../GeneralInput'
import GeneralInputMask from '../GeneralInputMask'

import LocaleSelect from 'components/LocaleSelect'
import { getFormattedAddressDetails } from 'helpers/address'
import { UserType } from 'types/user'

interface IDataReceivedItem {
  label: keyof IUserData
  value: string
}

export interface IDataItem {
  label: string
  value: string
  error?: string
  mandatory?: boolean
}

export interface IUserData {
  name: IDataItem
  phone: IDataItem
  cpf: IDataItem

  number?: IDataItem
  state?: IDataItem
  zip_code?: IDataItem
  street?: IDataItem
  city?: IDataItem
  complement?: IDataItem
  neighbourhood?: IDataItem
}

interface Props {
  userData: IUserData
  handleData: (IDataReceivedItem: IDataReceivedItem) => void
  subtitle: string
  userType: UserType
}

const UserExtraValues = ({ userData, handleData, subtitle, userType }: Props) => {
  const containerRef = useRef(null)

  const handleUserData = (value: string, label: keyof IUserData) => {
    handleData({ value, label })
  }

  const onSelectAddress = (location) => {
    geocodeByAddress(location.label).then((results) => {
      const { ...formattedAddress } = getFormattedAddressDetails(results[0])

      !!formattedAddress.city && handleUserData(formattedAddress.city, 'city')
      !!formattedAddress.neighbourhood && handleUserData(formattedAddress.neighbourhood, 'neighbourhood')
      !!formattedAddress.number && handleUserData(formattedAddress.number, 'number')
      !!formattedAddress.state && handleUserData(formattedAddress.state, 'state')
      !!formattedAddress.street && handleUserData(formattedAddress.street, 'street')
      !!formattedAddress.zip_code && handleUserData(formattedAddress.zip_code, 'zip_code')
    })
  }

  return (
    <div ref={containerRef} className='data-register-container'>
      <section className='personal-data'>
        <h3>Dados Pessoais</h3>
        <p>{subtitle}</p>
        <div className='full-width'>
          <GeneralInput
            label='Nome completo'
            value={userData.name.value}
            error={userData.name.error}
            handleChange={(e) => handleUserData(e.target.value, 'name')}
          />
          <GeneralInputMask
            label='Telefone'
            value={userData.phone.value}
            error={userData.phone.error}
            handleChange={(e) => handleUserData(e.target.value, 'phone')}
            mask={['(', /\d/, /\d/, ')', /\d/, /\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/]}
          />
          <GeneralInputMask
            label='CPF'
            mask={[/\d/, /\d/, /\d/, '.', /\d/, /\d/, /\d/, '.', /\d/, /\d/, /\d/, '-', /\d/, /\d/]}
            value={userData.cpf.value}
            error={userData.cpf.error}
            handleChange={(e) => handleUserData(e.target.value, 'cpf')}
          />
        </div>
      </section>

      {userType === 'owner' && (
        <section>
          <div className='full-width'>
            <h3>Endereço</h3>

            <div style={{ margin: '16px 0 32px' }}>
              <p style={{ marginBottom: 16 }}>Procurar endereço</p>
              <GooglePlacesAutocomplete
                selectProps={{
                  onChange: onSelectAddress,
                  placeholder: 'Digite o endereço do imóvel',
                  loadingMessage: () => 'Carregando...',
                  noOptionsMessage: () => 'Endereço não encontrado',
                }}
              />
            </div>
            <>
              <div className='width-adjuster'>
                <LocaleSelect
                  onChange={(e) => handleUserData(e, 'state')}
                  value={userData.state!.value}
                  error={userData.state!.error}
                />
              </div>
              <GeneralInput
                label='Cidade'
                value={userData.city!.value}
                error={userData.city!.error}
                handleChange={(e) => handleUserData(e.target.value, 'city')}
              />
              <GeneralInput
                label='Rua'
                value={userData.street!.value}
                error={userData.street!.error}
                handleChange={(e) => handleUserData(e.target.value, 'street')}
              />
              <GeneralInput
                label='Bairro'
                value={userData.neighbourhood!.value}
                error={userData.neighbourhood!.error}
                handleChange={(e) => handleUserData(e.target.value, 'neighbourhood')}
              />

              <div className='input-row'>
                <GeneralInput
                  handleChange={(e) => handleUserData(e.target.value, 'number')}
                  value={userData.number!.value}
                  error={userData.number!.error}
                  label='Número'
                />
                <GeneralInput
                  label='Complemento'
                  value={userData.complement!.value}
                  error={userData.complement!.error}
                  handleChange={(e) => handleUserData(e.target.value, 'complement')}
                />
              </div>

              <GeneralInputMask
                label='CEP'
                mask={[/\d/, /\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/]}
                value={userData.zip_code!.value}
                error={userData.zip_code!.error}
                handleChange={(e) => handleUserData(e.target.value, 'zip_code')}
              />
            </>
          </div>
        </section>
      )}
    </div>
  )
}

export default UserExtraValues
